import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './main.css';
import { Settings } from 'luxon';
import { OneSignalInit } from './utils/Notification';
import { migrateStorage } from './utils/storage';
import odoo from './utils/odoo';
import { init as globalInit } from './utils/Global';

const container = document.getElementById('root');
const root = createRoot(container!);

Settings.defaultLocale = 'fr';
// Settings.defaultZone = 'utc';

(async () => {
    await migrateStorage();
    await odoo.init();
    await globalInit();

    root.render(
        <React.StrictMode>
            <App />
        </React.StrictMode>
    );
})();

OneSignalInit();
